import { createApp } from "vue";
import PlanMap from "./PlanMap.vue";
import store from "./store/store";
import { i18n } from '../../i18n';

if (document.querySelector('#plan_map')) {
  const app = createApp(PlanMap)
  app.use(store)
  app.use(i18n);
  app.mount('#plan_map')
}
